import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderEntreprise from '../../header/headerEntreprise';
import CandidatureDetailsCommon from '../../commun/CandidatureDetailsCommon';
import CustomAlert from '../../commun/CustomAlert';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';

const DetailsCandidature = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const authToken = localStorage.getItem('authToken');

  const [candidature, setCandidature] = useState(null);
  const [editedStatut, setEditedStatut] = useState(null);
  const [messageEntreprise, setMessageEntreprise] = useState(candidature?.messageEntreprise || '');
  const [dateEntretien, setDateEntretien] = useState(candidature?.dateEntretien || '');
  
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  const setAlert = (severity, message) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  useEffect(() => {
    if (!authToken) return navigate('/');
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        setCandidature(data);
        setEditedStatut(data.statut);
        setMessageEntreprise(data.messageEntreprise || '');
        setDateEntretien(data.dateEntretien || '');
      } catch (err) {
        setAlert('error', 'Erreur lors du chargement de la candidature');
      }
    };
    fetchData();
  }, [id, authToken, API_BASE, navigate]);
  

  const handleSave = async () => {
    if (editedStatut === 'Accepté pour entretien' && !dateEntretien) {
      setAlert('error', "La date d'entretien est obligatoire.");
      return;
    }
  
    if (
      (editedStatut === 'Refusé avant entretien' || editedStatut === 'Non retenu après entretien') &&
      !messageEntreprise.trim()
    ) {
      setAlert('error', 'La raison du refus est obligatoire.');
      return;
    }
    
    if (editedStatut === candidature.statut) return navigate('/Entreprise/Candidatures');
    try {
      const res = await fetch(`${API_BASE}/api/candidatures/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          statut: editedStatut,
          messageEntreprise,
          dateEntretien
        })
              });

      if (res.ok) {
        setAlert('success', 'Statut mis à jour avec succès');
        setTimeout(() => navigate('/Entreprise/Candidatures'), 1500);
      } else {
        setAlert('error', 'Erreur lors de la mise à jour du statut');
      }
    } catch (err) {
      setAlert('error', 'Erreur serveur. Veuillez réessayer.');
    }
  };

  const handleCancel = () => navigate('/Entreprise/Candidatures');

  return (
    <>
      <CandidatureDetailsCommon
   HeaderComponent={HeaderEntreprise}
  headerProps={{
    entrepriseName: localStorage.getItem('entrepriseName'),
    authToken,
    userRole: 'entreprise'
  }}
  candidature={candidature}
  editedStatut={editedStatut}
  setEditedStatut={setEditedStatut}
  messageEntreprise={messageEntreprise}
  setMessageEntreprise={setMessageEntreprise}
  dateEntretien={dateEntretien}
  setDateEntretien={setDateEntretien}
  onCancel={handleCancel}
  onSave={handleSave}
  API_BASE={API_BASE}
  editable={true}
/>
<Footer />
      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
<Chatbox userRole="entreprise" />
</>
  );
};

export default DetailsCandidature;
